import { BoardClimbEditor } from '../components/climbs/climb-editor/BoardClimbEditor';
import { PhotoClimbEditor } from '../components/climbs/climb-editor/PhotoClimbEditor';
import { useClimbEditorRoute } from '../components/climbs/climb-editor/useClimbEditorRoute';
import { useHideAppFooter } from '../contexts/app-footer-context';

/**
 * The one page every climb is put up and corrected on.
 *
 * Three blocks, full width, stacked: what is being drawn *with*, what is being
 * drawn *on*, and the few fields that identify the climb. Then one button in the
 * corner that saves it. Only the middle block really changes between the kinds
 * of climb — a board's grid, or a photo of a wall — which is why this is a
 * choice between two branches rather than one form full of conditionals.
 *
 * Which branch is the URL's answer, not a control here: a setter arrives from
 * the wall they are setting, and being asked again what they came to do is a
 * question with only one right answer. See `useClimbEditorRoute`.
 */
export default function ClimbEditorPage() {
  const route = useClimbEditorRoute();
  // The fields are the last thing on this page; a footer under them is only
  // more to scroll past to reach the save.
  useHideAppFooter();

  return route.type === 'BoardClimb' ? (
    <BoardClimbEditor route={route} />
  ) : (
    <PhotoClimbEditor route={route} />
  );
}
